import { useMemo } from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { DateTimeFormat, formatDate } from '@razz-team/utils';

export interface DateTimeProps extends Omit<TypographyProps, 'children'> {
  value: string | number | Date | undefined | null;
  format?: DateTimeFormat;
}

export function useFormattedDateTime(
  value: string | number | Date | undefined | null,
  format: DateTimeFormat = 'datetime',
) {
  const text = useMemo(() => (value ? formatDate(value, format) : undefined), [value, format]);

  return text;
}

export function DateTime({ value, format = 'datetime', ...props }: DateTimeProps) {
  const text = useFormattedDateTime(value, format);
  return (
    <Typography component="span" {...props}>
      {text}
    </Typography>
  );
}
